module.exports={select:"Selecionar",selected:"Selecionado"};